const makeConstant = (constant) => `org/${constant}`

export const SET_HANDLE = makeConstant('SET_HANDLE')
export const SET_NEW_ONBOARDING = makeConstant('SET_NEW_ONBOARDING')

export const CREATE_ORG = makeConstant('CREATE_ORG')
export const CREATE_ORG_SUCCESS = makeConstant('CREATE_ORG_SUCCESS')
export const CREATE_ORG_PENDING = makeConstant('CREATE_ORG_PENDING')
export const CREATE_ORG_FAILED = makeConstant('CREATE_ORG_FAILED')

export const SKIP_REDIRECT_AFTER_NS_ORG_CREATION = makeConstant(
  'SKIP_REDIRECT_AFTER_NS_ORG_CREATION'
)
export const SIGNUP = makeConstant('SIGNUP')
export const SIGNUP_SUCCESS = makeConstant('SIGNUP_SUCCESS')
export const SIGNUP_PENDING = makeConstant('SIGNUP_PENDING')
export const SIGNUP_FAILED = makeConstant('SIGNUP_FAILED')

export const UPDATE_ORG = makeConstant('UPDATE_ORG')
export const UPDATE_ORG_SUCCESS = makeConstant('UPDATE_ORG_SUCCESS')
export const UPDATE_ORG_PENDING = makeConstant('UPDATE_ORG_PENDING')
export const UPDATE_ORG_FAILED = makeConstant('UPDATE_ORG_FAILED')

export const FETCH_ORG = makeConstant('FETCH_ORG')
export const FETCH_ORG_SUCCESS = makeConstant('FETCH_ORG_SUCCESS')
export const FETCH_ORG_PENDING = makeConstant('FETCH_ORG_PENDING')
export const FETCH_ORG_FAILED = makeConstant('FETCH_ORG_FAILED')

export const FETCH_ORG_PROPERTIES_SUCCESS = makeConstant(
  'FETCH_ORG_PROPERTIES_SUCCESS'
)
export const FETCH_ORG_PROPERTIES_FAILED = makeConstant(
  'FETCH_ORG_PROPERTIES_FAILED'
)

export const FETCH_ORG_USERS_SUCCESS = makeConstant('FETCH_ORG_USERS_SUCCESS')
export const FETCH_ORG_USERS_PENDING = makeConstant('FETCH_ORG_USERS_PENDING')
export const FETCH_ORG_USERS_FAILED = makeConstant('FETCH_ORG_USERS_FAILED')
export const CREATE_ORG_WITHOUT_REDIRECT_SUCCESS = makeConstant(
  'CREATE_ORG_WITHOUT_REDIRECT_SUCCESS'
)

export const SET_COLOR = makeConstant('SET_COLOR')

export const SET_LOCALE = makeConstant('SET_LOCALE')
export const SET_ICON = makeConstant('SET_ICON')
export const SET_WELCOME_MESSAGE = makeConstant('SET_WELCOME_MESSAGE')
export const SET_INSTALL_OPTION = makeConstant('SET_INSTALL_OPTION')
export const SET_CREATE_ORG_ERROR = makeConstant('SET_CREATE_ORG_ERROR')
export const RESET_ORG_ERROR = makeConstant('RESET_ORG_ERROR')
export const SET_OAUTH_ERROR = makeConstant('SET_OAUTH_ERROR')

export const UPDATE_ORG_PROPERTIES = makeConstant('UPDATE_ORG_PROPERTIES')
export const UPDATE_ORG_PROPERTIES_SUCCESS = makeConstant(
  'UPDATE_ORG_PROPERTIES_SUCCESS'
)
export const UPDATE_ORG_PROPERTIES_PENDING = makeConstant(
  'UPDATE_ORG_PROPERTIES_PENDING'
)
export const UPDATE_ORG_PROPERTIES_FAILED = makeConstant(
  'UPDATE_ORG_PROPERTIES_FAILED'
)

export const UPDATE_EMBED = makeConstant('UPDATE_EMBED')
export const UPDATE_EMBED_SUCCESS = makeConstant('UPDATE_EMBED_SUCCESS')
export const UPDATE_EMBED_PENDING = makeConstant('UPDATE_EMBED_PENDING')
export const UPDATE_EMBED_FAILED = makeConstant('UPDATE_EMBED_FAILED')

export const UPDATE_WELCOME_MESSAGE = makeConstant('UPDATE_WELCOME_MESSAGE')
export const UPDATE_WELCOME_MESSAGE_SUCCESS = makeConstant(
  'UPDATE_WELCOME_MESSAGE_SUCCESS'
)
export const UPDATE_WELCOME_MESSAGE_PENDING = makeConstant(
  'UPDATE_WELCOME_MESSAGE_PENDING'
)
export const UPDATE_WELCOME_MESSAGE_FAILED = makeConstant(
  'UPDATE_WELCOME_MESSAGE_FAILED'
)

export const CHECK_UNIQUE_HANDLE = makeConstant('CHECK_UNIQUE_HANDLE')
export const CHECK_UNIQUE_HANDLE_SUCCESS = makeConstant(
  'CHECK_UNIQUE_HANDLE_SUCCESS'
)
export const CHECK_UNIQUE_HANDLE_FAILED = makeConstant(
  'CHECK_UNIQUE_HANDLE_FAILED'
)

export const FETCH_EMBED = makeConstant('FETCH_EMBED')
export const FETCH_EMBED_SUCCESS = makeConstant('FETCH_EMBED_SUCCESS')
export const FETCH_EMBED_PENDING = makeConstant('FETCH_EMBED_PENDING')
export const FETCH_EMBED_FAILED = makeConstant('FETCH_EMBED_FAILED')

export const EXCHANGE_GOOGLE_CODE_FOR_DRIFT_CODE = makeConstant(
  'EXCHANGE_GOOGLE_CODE_FOR_DRIFT_CODE'
)
export const EXCHANGE_MICROSOFT_CODE_FOR_DRIFT_CODE = makeConstant(
  'EXCHANGE_MICROSOFT_CODE_FOR_DRIFT_CODE'
)
export const EXCHANGE_THIRD_PARTY_CODE_SUCCESS = makeConstant(
  'EXCHANGE_THIRD_PARTY_CODE_SUCCESS'
)
export const EXCHANGE_THIRD_PARTY_CODE_FAILED = makeConstant(
  'EXCHANGE_THIRD_PARTY_CODE_FAILED'
)
export const THIRD_PARTY_ONBOARDING_REDIRECT = makeConstant(
  'THIRD_PARTY_ONBOARDING_REDIRECT'
)
export const THIRD_PARTY_ONBOARDING_SIGN_IN = makeConstant(
  'THIRD_PARTY_ONBOARDING_SIGN_IN'
)
export const TRACK_BIZIBLE_NEW_PQL = makeConstant('TRACK_BIZIBLE_NEW_PQL')

export const Locale = Object.freeze({
  zh: 'zh',
  hr: 'hr',
  da: 'da',
  nl: 'nl',
  en: 'en',
  et: 'et',
  fi: 'fi',
  fr: 'fr',
  ka: 'ka',
  de: 'de',
  'de-DE-formal': 'de-DE-formal',
  hi: 'hi',
  hu: 'hu',
  is: 'is',
  it: 'it',
  ja: 'ja',
  ko: 'ko',
  nb: 'nb',
  pl: 'pl',
  pt: 'pt',
  'pt-BR': 'pt-BR',
  ro: 'ro',
  ru: 'ru',
  sr: 'sr',
  sl: 'sl',
  es: 'es',
  sv: 'sv',
  th: 'th',
  tr: 'tr',
  vi: 'vi',
})

export const InstallOptions = Object.freeze({
  JAVASCRIPT: 'JAVASCRIPT',
  WORDPRESS: 'WORDPRESS',
})
